module.exports = __webpack_public_path__ + "img/13_broadway_market_new.71e4b149.jpg";